<template>
    <Head :title="$t('auth.invalidToken')" />

    <jet-authentication-card class="bg-minplan-blue">
        <template #logo>
            <img class="h-8 w-auto" src="../../../image/immivo.svg" alt="immivo" />
        </template>

        <div class="mb-4 text-sm text-gray-600">
            {{ $t("auth.invalidToken") }}
        </div>
        <primary-button >
            {{ $t("auth.login") }}
        </primary-button>
    </jet-authentication-card>
</template>

<script>
import { Head } from "@inertiajs/inertia-vue3";
import JetAuthenticationCard from "@/Jetstream/AuthenticationCard.vue";
import JetAuthenticationCardLogo from "@/Jetstream/AuthenticationCardLogo.vue";
import PrimaryButton from "@/Jetstream/PrimaryButton.vue";

export default {
    name: "InvalidToken",
    components: {
        PrimaryButton,
        Head,
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
    },
};
</script>

<style scoped></style>
